import React, { useEffect, useState } from "react";
import UserProfile from "src/components/Users/UserProfile";

const Members = ({ group, type, className = "" }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (group.users?.length > 0) {
      setUsers(group.users.slice(0, 3));
    } else {
      setUsers([]);
    }
  }, [group?.users]);

  return (
    <>
      <div className={`flex w-36 items-center justify-center ${className}`}>
        <div className="flex items-center -space-x-2">
          {users &&
            users.map((user, index) => {
              return (
                <div
                  key={user?._id || user?.id}
                  className="z-20 h-6 w-6 overflow-hidden rounded-full ring-2 ring-white ring-offset-0">
                  <UserProfile
                    user={user}
                    size="sm"
                  />
                </div>
              );
            })}
        </div>
        <div className="flex items-center justify-center text-sm font-medium text-gray-400">
          {group.users?.length > 0 ? (
            group.users?.length > 3 ? (
              <div className="ml-2">
                +{group.users.length - 3} other{group.users.length - 3 > 1 ? "s" : ""}
              </div>
            ) : (
              <div className="ml-2">{group.users?.length + ` ${type || "user"}${group.users?.length > 1 ? "s" : ""}`}</div>
            )
          ) : (
            `No ${type || "user"}s`
          )}
        </div>
      </div>
    </>
  );
};

export default Members;
